import React from "react";
import ReactDOM from "react-dom/client";
import Routes from "./Routes/Routes.js"
import Navbar from "./Components/Navbar/Navbar.js";
import NotificationBar from "./Components/NotificationBar/NotificationBar.js";


import {RouterProvider, createBrowserRouter, Outlet} from "react-router-dom";
import store from './store.js';
import { Provider } from 'react-redux';

const AppLayout = () => (
	<>
		<Navbar/>
		<NotificationBar/>
		<Outlet/>
	</>
);

const router = createBrowserRouter([
	{
		element: <AppLayout/>,
		children: Routes
	}
]);
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<React.StrictMode>
		<Provider store={store}>
	        <RouterProvider router={router}/>
		</Provider>
	</React.StrictMode>
);